// Vendor
import * as React from 'react';
import { Image } from '@src/components/Image/Image';

const CurrentResaleLandscape: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1>The Current Resale Landscape</h1>
      <p className="tup-body">
        A quick reference to where the major players in the industry currently
        reside.
      </p>
      <Image alt="Resale Landscape Chart" fileName="resale-landscape.png" />
    </div>
  );
};

export { CurrentResaleLandscape };
